'use strict';

if (!Symbol.species) {
    Symbol.species = Symbol.for('@@species');
}



//////////////////
// WEBPACK FOOTER
// ./~/ml-pls/~/ml-matrix/src/symbol-species.js
// module id = 291
// module chunks = 0